module.exports = __webpack_public_path__ + "img/logo.8ddf77d1.gif";